module.exports = __webpack_public_path__ + "img/side invisible zipper length.4b24ce95.png";